import { ReactNode } from "react";

interface FileThumbnailProps {
  icon?: ReactNode;
  image?: string;
  title: string;
  subtitle: ReactNode;
  error?: boolean;
  onClick?: () => void;
}

export const FileThumbnail = ({
  icon,
  image,
  title,
  subtitle,
  error = false,
  onClick,
}: FileThumbnailProps) => (
  <div className="flex cursor-pointer items-center gap-3" onClick={onClick}>
    <div className="flex h-12 w-12 items-center justify-center rounded bg-gray-200">
      {image ? (
        <img src={image} className="h-full w-full rounded object-cover" alt="file preview" />
      ) : (
        icon
      )}
    </div>
    <div className="min-w-0 flex-1">
      <div className="text-sm font-medium text-gray-900">
        {title}
        {error && <span className="text-red-500"> (Error)</span>}
      </div>
      <div className="text-xs text-gray-500">{subtitle}</div>
    </div>
  </div>
);
